import { render, staticRenderFns } from "./JourneyCoverPicker.vue?vue&type=template&id=2bc39a04&scoped=true"
import script from "./JourneyCoverPicker.vue?vue&type=script&lang=js"
export * from "./JourneyCoverPicker.vue?vue&type=script&lang=js"
import style0 from "./JourneyCoverPicker.vue?vue&type=style&index=0&id=2bc39a04&prod&scoped=true&lang=css"
import style1 from "./JourneyCoverPicker.vue?vue&type=style&index=1&id=2bc39a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc39a04",
  null
  
)

export default component.exports